import { atom } from 'jotai';
import callApi from 'lib/callApi';
import { showFailureToast } from 'lib/ToastHelper';
import { companyIdAtom } from 'views/state';

// Helper method to fetch QIDs
const fetchExcludedQIDs = async (companyId: number) => {
  try {
    const responseData = await callApi(`companies/${companyId}`, 'GET');
    return responseData?.data;
  } catch (error) {
    showFailureToast('Failed to load excluded QIDs.');
    return {
      excludedWAQIDs: '',
      excludedEPQIDs: '',
      excludedCAQIDs: '',
    };
  }
};

// Single atom to fetch and store QIDs
export const excludedQIDsAtom = atom(async (get) => {
  const companyId = get(companyIdAtom);
  const data = await fetchExcludedQIDs(companyId);

  return {
    excludedWAQIDs: data.excluded_qids || '',
    excludedEPQIDs: data.excluded_ep_qids || '',
    excludedCAQIDs: data.excluded_ca_qids || '',
  };
});
